/**
 * editCartExtraController - used for editing extras that have made their way into te
 */
bookingApp.controller('editCartExtraController', function($scope, $routeParams, $http){
    $scope.editingExtra = true;
    $scope.cartExtra = null;

    // setup footer
    $scope.setupStandardCartFooter();
    $scope.footer.display.next = false;
    if($scope.property.isItemOnly){
        $scope.setupItemOnlyFooter();
    }

    // check if the extra is a booking level or room level extra
    $scope.levels = ['Booking', 'Room'];
    $scope.level = $scope.levels[0];
    $scope.roomIndex = null;
    if(typeof $routeParams.roomId === 'undefined'){
        $scope.level = $scope.levels[0];
    } else {
        $scope.level = $scope.levels[1];
        $scope.roomIndex = $routeParams.roomId;
    }
    $scope.extraIndex = $routeParams.extraId;

    // get the specific extra from the stack
    if($scope.level === $scope.levels[0]){ // find from booking level
        $scope.cartExtra = $scope.cart.bookingExtras.selected[$scope.extraIndex];
        $scope.specificExtra = $scope.cartExtra.extra;
    } else { // find from room level
        $scope.cartExtra = $scope.cart.rooms[$scope.roomIndex].selectedExtras[$scope.extraIndex];
        $scope.specificExtra = $scope.cartExtra.extra;
    }
    $scope.selectedExtra = $scope.specificExtra;

    // setup the initial selected values
    // pax config
    if($scope.property.isItemOnly){
        $scope.selectedAdults = 0;
        $scope.selectedChildren = 0;
        $scope.selectedInfants = 0;
    }else {
        $scope.selectedAdults = $scope.cartExtra.paxConfig.adults;
        $scope.selectedChildren = $scope.cartExtra.paxConfig.children;
        $scope.selectedInfants = $scope.cartExtra.paxConfig.infants;
    }
    // dates
    $scope.selectedFrom = $scope.cartExtra.extraStart;
    $scope.selectedTo = $scope.cartExtra.extraEnd;
    // quantity
    $scope.selectedQuantity = $scope.cartExtra.quantity;

    // get the photos for the carousel
    $scope.getPhotos = function(){
        return $scope.extras.extrasPhotos[$scope.specificExtra.id];
    };

    // get the descrioption for the extra
    $scope.getDescription = function(){
        return $scope.cartExtra.extra.description;
    };

    // setup the pricing object to be passed into the selector directive - acts as a wrapper for the extra modules pricing function
    $scope.pricing = function(quantity, startDate, endDate, adults, children, infants, isItemOnly){
        // update to take into consideration adults / children / infants
        var priceOb = $scope.extras.checkPricing(parseInt($scope.specificExtra.category.id), parseInt($scope.specificExtra.id), moment(startDate).toDate(), moment(endDate).toDate(), quantity, $scope.extras.extras, $scope.extras.extrasPrices, ExtraPricing.buildPaxConfiguration(adults, children, infants), isItemOnly);
        return priceOb;
    };

    // get the previously saved extra pax details,
    $scope.getPreviouslyLoadedDetails = function(){
        return $scope.cartExtra;
    };

    // control functionality
    $scope.editExtraFunc = function(extraStart, extraEnd, adults, children, infants, quantity, startTime, endTime, paxDetails){
        // dates / times
        $scope.cartExtra.extraStart = extraStart;
        $scope.cartExtra.extraEnd = extraEnd;
        $scope.cartExtra.startTime = startTime;
        $scope.cartExtra.endTime = endTime;
        // pax configs
        $scope.cartExtra.paxConfig.adults = adults;
        $scope.cartExtra.paxConfig.children = children;
        $scope.cartExtra.paxConfig.infants = infants;
        // quantity
        $scope.cartExtra.quantity = quantity;
        // update the pricing object
        var priceOb = $scope.extras.checkPricing(
            parseInt($scope.cartExtra.extra.category.id),
            parseInt($scope.cartExtra.extra.id),
            moment(extraStart).toDate(),
            moment(extraEnd).toDate(),
            quantity,
            $scope.extras.extras,
            $scope.extras.extrasPrices,
            ExtraPricing.buildPaxConfiguration(adults, children, infants),
            isItemOnly
        );
        $scope.cartExtra.pricing = priceOb;
        // update the pax details
        $scope.cartExtra.paxDetails = paxDetails;
        $scope.cartExtra.paxDetails.formattedDOB = moment(paxDetails.dob).format('YYYY-MM-DD');
        // send the user back to the cart
        $scope.goToCart();
    };
    $scope.removeExtraFunc = function(){
        if($scope.level === $scope.levels[0]){ // remove from booking level extras
            $scope.cart.bookingExtras.selected.splice($scope.extraIndex, 1);
        } else { // remove from room level extras
            $scope.cart.rooms[$scope.roomIndex].selectedExtras.splice($scope.extraIndex, 1);
        }
        // redirect back to the cart
        $scope.goToCart();
    };

    $scope.getMax = function () {
        // get the max qunaityt and the max from the rate then take the lowest value for these.
        var specificExtra = $scope.extras.getSpecificExtra($scope.specificExtra.category.id, $scope.specificExtra.id);
        var maxPerBooking = specificExtra.maxPerBooking;
        var maxQuantity = null;
        for (rate in specificExtra.rates) {
            if (specificExtra.rates.hasOwnProperty(rate)) {
                var tmpMaxQuantity = specificExtra.rates[rate].maxQuantity;
                if (!maxQuantity) {
                    maxQuantity = tmpMaxQuantity;
                } else {
                    if (maxQuantity > tmpMaxQuantity) {
                        maxQuantity = tmpMaxQuantity;
                    }
                }
            }
        }
        if (maxQuantity && maxPerBooking) {
            if (maxQuantity > maxPerBooking) {
                return maxQuantity;
            } else {
                return maxPerBooking;
            }
        } else {
            return '';
        }
    };

});